import React from "react";
import bgImage from "../../../../images/main/main8.jpg";

const HostingBackground = ({ children }) => (
  <div className="relative bg-no-repeat bg-cover bg-center" style={{ backgroundImage: `url(${bgImage})` }}>
    {children}
  </div>
);

export default HostingBackground; 